<div class="options-container">
  <div class="avatar-wrapper">
    <onyx-avatar
      variant="user"
      [size]="16"
      [user]="{
        firstName: driver().name.split(' ')[0],
        lastName: driver().name.split(' ')[1] || driver().name,
      }"
    ></onyx-avatar>

    {{ driver().name }}
  </div>

  @let phone = driver().phone;
  <div class="options">
    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="24"
      icon="telephone-outlined"
      [onyxTooltip]="phoneTooltipTemplate"
      [onyxTooltipTemplateContext]="{ phone }"
      (click)="ActionHelper.makeCall(phone)"
    ></onyx-icon-button>
  </div>
</div>

<ng-template let-phone="phone" #phoneTooltipTemplate>
  <div class="phone">
    {{ 'labels.call' | translate }}
    {{ phone | onyxPhone }}
  </div>
</ng-template>
